// src/utils/analytics.ts
export type AnalyticsEventParams = Record<string, unknown>;

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: any[]) => void;
  }
}

export function trackEvent(action: string, params?: AnalyticsEventParams) {
  if (typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    ((...args: any[]) => {
      window.dataLayer!.push(args);
    });

  window.gtag('event', action, params ?? {});
}

export function trackPageView(pagePath: string) {
  trackEvent('page_view', {
    page_path: pagePath,
    page_location: window.location.href,
    page_title: document.title,
  });
}